import {useEffect} from 'react'

const useOutsideClick = (ref, callback, executeHook = true, excludeReactModal = false) => {
  function isTriggeredByModal(event) {
    return event.srcElement.id === 'modalConfirmButton' || event.srcElement.id.includes('modalCancelButton')
  }

  const handleOutsideClick = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      if (excludeReactModal && isTriggeredByModal(event)) {
        return
      }
      callback()
    }
  }

  useEffect(() => {
    if (executeHook) {
      document.addEventListener('mousedown', handleOutsideClick)
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  })

  return {handleOutsideClick}
}

export default useOutsideClick
